import { render, staticRenderFns } from "./mygeli.vue?vue&type=template&id=5b492c68&"
import script from "./mygeli.vue?vue&type=script&lang=js&"
export * from "./mygeli.vue?vue&type=script&lang=js&"
import style0 from "./mygeli.vue?vue&type=style&index=0&id=5b492c68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports